import React, { useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import adhaan from "../../images/FlipjoblogoResize.png"
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import * as constants from '../../utils/Constants'
import { CircularProgress } from '@mui/material';
import forgetPwd1 from "../../images/login_bg/forgetPwd1.gif"

const ForgotPassword = ({ history }) => {
  const [isSpin, setIsSpin] = useState(false)
  const [loginData, setLoginData] = useState({})
  var state = useLocation().state;
  const handleBlur = (e) => {
    const newLoginData = { ...loginData }
    newLoginData[e.target.name] = e.target.value
    setLoginData(newLoginData)
  }
  if (!state) {
    state = {
      emailId: '',
    }
  }
  const onSubmit = (e) => {
    setIsSpin(true)
    e.preventDefault();
    var url = constants.ForgotPasswordUrl;
    fetch(url, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        Schema: constants.Schema,
      },
      body: JSON.stringify(loginData)
    })
      .then((response) => response.json())
      .then((res) => {
        // console.log(res)
        if (res.message) {
          toast.success(`✅ ${res.message.messageDescription} !`, {
            position: 'top-right',
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          })

          setTimeout(() => {
            history.push({
              pathname: '/page-login',
              state: { email: loginData.emailId }
            })
          }, 3000);
        }
        else {
          toast.error(`❌ ${res.error?.errorMessage}`, {
            position: 'top-right',
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
          })
          setTimeout(() => {
            setIsSpin(false)
          }, 3000);
        }
      })

  };
  return (
    <div className="authentication h-100 p-meddle">
      <div className="container h-100"
        style={{ background: '#fff' }}
      >
        {" "}
        <div className="row justify-content-center h-100 align-items-center">
          <div className='col-md-4 show-results'>
            <img src={forgetPwd1} style={{ width: '330px', marginLeft: '20px' }} />
          </div>
          <div className="col-md-8">
            <div className="authentication-content" style={{ boxShadow: 'none' }}>
              <div className="row no-gutters">
                <div className="col-xl-9">
                  <div className="auth-form">
                    <div className="text-center mb-3">
                      <Link to='/'>
                        <img className="brand-title" src={adhaan} alt="" />
                      </Link>
                    </div>
                    <h4 className="text-center mb-4 text-#58595b">
                      Forgot Password
                    </h4>
                    <form onSubmit={(e) => onSubmit(e)}>
                      <div className="form-group">
                        <label className="text-#58595b">
                          <strong>Email</strong>
                        </label>
                        <input
                          type='email'
                          className='form-control Color-box'
                          defaultValue={state.emailId}
                          placeholder='Email'
                          name="emailId"
                          onChange={handleBlur}
                        />
                      </div>
                      <div className="text-center">
                        <ToastContainer />
                        {
                          isSpin ?
                            <button
                              type="button"
                              className="btn bg-white text-primary btn-block">
                              <CircularProgress
                                color='inherit' size={24}
                                sx={{
                                  color: 'green'
                                }} />
                            </button>
                            :
                            <input
                              type="submit"
                              value="SUBMIT"
                              className="btn btn-primary btn-block"
                              style={{ backgroundColor: '#00ADEE', border: 'none', boxShadow: 'none' }}
                            />
                        }

                      </div>
                    </form>
                    <div className='new-account mt-3 text-#58595b'>
                      <p>
                        Back Page{' '}
                        <Link style={{ color: '#00ADEE' }} to='/page-login'>
                          Sign in
                        </Link>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default ForgotPassword;